import styled from '@emotion/styled';
import Notice from '__components/Kizen/Notice';

export const StyledNotice = styled(Notice)`
  margin-bottom: 15px;
`;
